import { render, staticRenderFns } from "./StartCountingPopup.vue?vue&type=template&id=2dadc309"
import script from "./StartCountingPopup.vue?vue&type=script&lang=js"
export * from "./StartCountingPopup.vue?vue&type=script&lang=js"
import style0 from "./StartCountingPopup.vue?vue&type=style&index=0&id=2dadc309&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports